import { render } from "./ventas.vue?vue&type=template&id=f9fc211e&scoped=true"
import script from "./ventas.vue?vue&type=script&lang=js"
export * from "./ventas.vue?vue&type=script&lang=js"

import "./ventas.vue?vue&type=style&index=0&id=f9fc211e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fc211e"]])

export default __exports__